import { i18nNsFactory } from '@atlas-frontend/i18n';
import { z, ZodErrorMap } from 'zod/v3';
import { NAME_MAX_LENGTH } from '../../common/constants';
import { zValidPeriod } from '../../common/utils';
import translations from '../../common/utils/schema/common.translations.json';

const { addTranslations, t } = i18nNsFactory('alternative-alg-set-schema');
addTranslations(translations);

export const nameErrorMap: ZodErrorMap = (issue) => {
  if (issue.code === z.ZodIssueCode.too_big) {
    return { message: t('validation.too_big', { max: issue.maximum }) };
  }
  return { message: t('validation.field_required') };
};

export const AlternativeAlgorithmExceptionSchema = z.object({
  id: z.number().int().nullable(),
  validPeriod: zValidPeriod(),
  alternativeAlgorithmId: z.number().int().nullable(),
});

export const AlternativeAlgorithmExceptionFormSchema =
  AlternativeAlgorithmExceptionSchema.extend({
    alternativeId: z.string().nullable(),
  });

export const AlternativeAlgorithmSchema = z.object({
  id: z.number().int().nullable(),
  defaultAlgorithm: z.boolean(),
  groupCode: z.string().nullable(),
  algorithmId: z.number().int().nullable(),
  code: z.string().nullable(),
  exceptions: z.array(AlternativeAlgorithmExceptionSchema),
  alternativeAlgorithmSetId: z.number().int().nullable(),
});

export const AlternativeAlgorithmFormSchema = AlternativeAlgorithmSchema.omit({
  exceptions: true,
  groupCode: true,
  algorithmId: true,
  code: true,
}).extend({
  alternativeId: z.string().nullable(),
});

export const AlternativeAlgorithmSetSchema = z.object({
  id: z.number().int().nullable(),
  code: z.number().int(),
  name: z.string({ errorMap: nameErrorMap }).min(1).max(NAME_MAX_LENGTH),
  alternativeAlgorithms: z.array(AlternativeAlgorithmSchema),
});

export const AlternativeAlgorithmSetsSchema = z.array(
  AlternativeAlgorithmSetSchema,
);

export const AlternativeAlgorithmSetFormSchema =
  AlternativeAlgorithmSetSchema.omit({
    alternativeAlgorithms: true,
  }).extend({
    alternativeAlgorithms: z.array(AlternativeAlgorithmFormSchema),
    exceptions: z.array(AlternativeAlgorithmExceptionFormSchema),
  });
